app.directive('facebookShareButton', function ($window, $document) {
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            var urlToShare = $attrs.facebookShareButton;

            if (!urlToShare) {
                urlToShare = $document.find('link[rel="canonical"]').attr('href');
            }

            $element.on('click', function ($event) {
                $event.preventDefault();

                var FB = $window.FB;
                if (FB) {
                    FB.ui({
                        method: 'share',
                        href: urlToShare
                    }, function (response) {
                        /* Don't care about the results */
                    });
                }
            });
        }
    };
});